// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.presize-root body {
  min-width: 1024px;
  overflow: auto;
  background-color: #ffffff;
}
.presize-root .text-ellipsis {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.presize-root .align-right {
  text-align: right;
}
/*# sourceMappingURL=App.css.map */`, "",{"version":3,"sources":["webpack://./App.less","webpack://./src/App.less"],"names":[],"mappings":"AAAA;EAEE,iBAAA;EACA,cAAA;EACA,yBAAA;ACAF;ADJA;EAQE,gBAAA;EACA,uBAAA;EACA,mBAAA;ACDF;ADTA;EAcE,iBAAA;ACFF;AACA,kCAAkC","sourcesContent":[".presize-root { \n body {\n  min-width: 1024px;\n  overflow: auto;\n  background-color: #ffffff;\n}\n\n.text-ellipsis {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.align-right {\n  text-align: right;\n}\n \n}",".presize-root body {\n  min-width: 1024px;\n  overflow: auto;\n  background-color: #ffffff;\n}\n.presize-root .text-ellipsis {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n.presize-root .align-right {\n  text-align: right;\n}\n/*# sourceMappingURL=App.css.map */"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
